import {field} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";

export class ReconciliationReportData extends ReportData<ReconciliationReportData> {
}
